'use strict';

module.exports = function (ngModule) {
    ngModule.directive('services', require('./services'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/services/index.js
 **/